var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0853 2.5788L10.5852 0.328799C10.4811 0.276658 10.3661 0.249512 10.2496 0.249512C10.1331 0.249512 10.0182 0.276658 9.914 0.328799L5.75 2.41155L1.58525 0.328799C1.47088 0.271647 1.34379 0.244682 1.21607 0.250467C1.08834 0.256252 0.964215 0.294593 0.855477 0.36185C0.746739 0.429107 0.657 0.523045 0.594784 0.634744C0.532568 0.746442 0.49994 0.872192 0.5 1.00005V10.75C0.5 11.0343 0.6605 11.2938 0.91475 11.4213L5.41475 13.6713C5.51895 13.7234 5.63386 13.7506 5.75037 13.7506C5.86689 13.7506 5.9818 13.7234 6.086 13.6713L10.25 11.5885L14.4147 13.6705C14.5288 13.7282 14.6558 13.7556 14.7835 13.7499C14.9112 13.7443 15.0352 13.7058 15.1437 13.6383C15.365 13.501 15.5 13.2603 15.5 13V3.25005C15.5 2.9658 15.3395 2.7063 15.0853 2.5788ZM6.5 3.71355L9.5 2.21355V10.2865L6.5 11.7865V3.71355ZM2 2.21355L5 3.71355V11.7865L2 10.2865V2.21355ZM14 11.7865L11 10.2865V2.21355L14 3.71355V11.7865Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaces);
export default __webpack_public_path__ + "static/media/places.a1346efc832cc64ce3c5c355edfe751f.svg";
export { ForwardRef as ReactComponent };